import React, { useState } from "react";
import { downloadOrderInvoice } from "../../../lib/exportApi";

const DownloadInvoiceButton = ({
  orderId,
  className = "btn btn-primary",
  label = "Download Invoice",
  loadingLabel = "Generating…",
}) => {
  const [downloading, setDownloading] = useState(false);

  const handleClick = async () => {
    if (!orderId || downloading) return;
    setDownloading(true);
    try {
      await downloadOrderInvoice(orderId);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button
      type="button"
      className={className}
      onClick={handleClick}
      disabled={!orderId || downloading}
    >
      {downloading ? loadingLabel : label}
    </button>
  );
};

export default DownloadInvoiceButton;
